import { envConfig } from 'envConfig'

export const authConfig = {
    tenantId: '124ccfbd-07ea-44e3-8794-af8986d63809',
    clientId: envConfig.microsoftClientId,
    redirectUri: `${origin}/login_redirect`,
    scope: 'user.read',
}
